<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{'Activity_reports' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/" class="d-inline-block position-relative">
                <i class="ri-home-8-line"></i>
                {{'Dashboard' | translate}}
            </a>
        </li>
        <li class="breadcrumb-item position-relative">
            <a class="gap-icon" (click)="goPlantsDetails()">
                {{ 'Plant_details' | translate}}
            </a>
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Activity_reports' | translate}}
        </li>
    </ol>
</div>
<!-- Datepicker -->
<div class="row">
    <div class="col-xxl-12 mb-20">
        <app-basic-datepicker (dateChange)="onDateChange($event)" />
    </div>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="loading-container">
    <mat-card class="loading-card">
        <mat-progress-spinner mode="indeterminate" diameter="48" strokeWidth="5">
        </mat-progress-spinner>
    </mat-card>
</div>

<!-- No Data State -->
<div *ngIf="!loading && noDataForUser" class="empty-state-card">
    <mat-card class="empty-card">
        <div class="empty-icon-box">
            <mat-icon>info</mat-icon>
        </div>
        <h4>{{'No activity data found' | translate}}</h4>
        <p>{{ error }}</p>
    </mat-card>
</div>

<div *ngIf="!loading && !noDataForUser">
    <div class="col-lg-12 mb-20">
        <app-multiple-yaxis-chart *ngIf="!loading && !noDataForUser" [items]="chartItems">
        </app-multiple-yaxis-chart>
    </div>

    <div class="col-lg-12">
        <app-basic-heatmap-chart *ngIf="!loading && !noDataForUser" [items]="chartItems">
        </app-basic-heatmap-chart>
    </div>
</div>

<div class="col-lg-12 mb-20" *ngIf="!loading && !noDataForUser">
    <app-activity-totals [automatic]="reportBucket?.automaticTotals ?? []" [manual]="reportBucket?.manualTotals ?? []">
    </app-activity-totals>
</div>